<p-blockUI [blocked]="blocked">
  <p-progressSpinner></p-progressSpinner>
</p-blockUI>

<div class="card grid">
  <div class="xl:col-3 sm:col-6">
    <p-checkbox name="groupname" [binary]="true" label="Доп склад 1" [(ngModel)]="allowImpStock" (onChange)="onProductionMode($event)" class="mb-2"></p-checkbox>
    <app-departmentselector [showLabel]="false" [parentCompany]="newDocument.DOCMANCLIID" [disabled]="!allowImpStock" [selectedID]="stock1" (selectedDepartmentID)="stock1Selected($event)"></app-departmentselector>
  </div>
  <div class="xl:col-3 sm:col-6">
    <p-checkbox name="groupname" [binary]="true" label="Доп склад 2" [(ngModel)]="allowAuxStock" (onChange)="onProductionMode($event)" class="mb-2"></p-checkbox>
    <app-departmentselector [showLabel]="false" [parentCompany]="newDocument.DOCMANCLIID" [disabled]="!allowAuxStock" [selectedID]="stock2" (selectedDepartmentID)="stock2Selected($event)"></app-departmentselector>
  </div>
  <div class="xl:col-3 sm:col-6">
    <p-checkbox name="groupname" [binary]="true" label="Доп склад 3" [(ngModel)]="allowMainStock" (onChange)="onProductionMode($event)" class="mb-2"></p-checkbox>
    <app-departmentselector [showLabel]="false" [parentCompany]="newDocument.DOCMANCLIID" [disabled]="!allowMainStock" [selectedID]="stock3" (selectedDepartmentID)="stock3Selected($event)"></app-departmentselector>
  </div>
  <div class="xl:col-3 sm:col-6">
    <label class="block mb-2">Склад сборки</label>
    <app-departmentselector [showLabel]="false" [parentCompany]="newDocument.DOCMANCLIID" [selectedID]="stock4" (selectedDepartmentID)="stock4Selected($event)"></app-departmentselector>
  </div>
</div>

<p-fieldset #shwome1 legend="Сборные изделия ({{productionMode}} - {{selectedManufacturedItem}})" *ngIf="thereIsManufacturedItems">
  <div class="grid">
    <div class="col-8">
      <p-radioButton name="groupname" value="m2" class="col-12 mb-1" [(ngModel)]="productionMode" (onClick)="onProductionMode($event)" label="Подобрать для одного товара"></p-radioButton>
      <p-radioButton name="groupname" value="m1" class="col-12" [(ngModel)]="productionMode" (onClick)="onProductionMode($event)" label="Автоматически подобрать все"></p-radioButton>
      <div class="grid">
        <div class="col-10 mt-2">
          <p-dropdown [options]="products" [dataKey]="prodid" [(ngModel)]="selectedManufacturedItem" optionLabel="prodname" optionValue="prodid"
                      class="p-button-help" [disabled]="(productionMode != 'm2')"
                      (onChange)="onSelectedItemChange($event)" placeholder="Выбрать товар..."
                      filter="true" filterPlaceholder="Найти по коду..."
                      pTooltip="Товары в документе {{serialProdId}}" tooltipPosition="top">
          </p-dropdown>
        </div>
        <div class="col-2 mt-2">
          <input pInputText type="number" [(ngModel)]="numberOfItemsToProduce" step="1" min="1" [max]="maxItemsToProduce"
                 style="text-align: right" (change)="onNumberOfItemsToProduceChange($event)"
                 placeholder="Кол-во" pTooltip="Количество для производства" tooltipPosition="top">
        </div>
      </div>
    </div>
    <div class="card col-4">
      <p-checkbox class="ml-2 mt-2" [(ngModel)]="doNotCheckProduction" [binary]="true" (onChange)="onProductionMode($event)" label="Не учитывать готовые на складе"></p-checkbox>
      <p-checkbox class="ml-2 mt-2" [(ngModel)]="doNotCheckPrevious" [binary]="true" (onChange)="onProductionMode($event)" label="Не проверять предыдущие передачи"></p-checkbox>
      <p-checkbox class="ml-2 mt-2" [(ngModel)]="moveProductionBack" [binary]="true" (onChange)="onProductionMode($event)" label="Вернуть готовое изделие на склад для отгрузки"></p-checkbox>
    </div>
  </div>
</p-fieldset>
